const currency = (value, options, symbol = '₮') => {
  try {
    switch (options) {
      case 'round':
        return `${parseFloat(_.round(value, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${symbol}`;
      case 'integer':
        return `${parseFloat(_.round(value, 2)).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${symbol}`;
      case 'no-precision':
        return new Intl.NumberFormat().format(parseFloat(_.round(value, 2)))
      default:
        let validated = '-.--';
        if (value != null && !isNaN(value)) {
          validated = parseFloat(_.ceil(value, 2)).toFixed(2)
        }
        return `${validated.replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${symbol}`;
    }
  } catch (e) {
    console.error(e);
    return value;
  }
};

export { currency };
